var map = {
	"./MyPethealth_Privacy_Policy_CA.pdf": 460,
	"./MyPethealth_Privacy_Policy_US.pdf": 461,
	"./MyPethealth_Terms_of_Use.pdf": 462,
	"./Spot_Privacy_Policy_CA.pdf": 463,
	"./Spot_Terms_of_Use_CA.pdf": 464,
	"./Spot_accessibility.pdf": 125,
	"./merck_privacy_policy_USA.pdf": 465,
	"./merck_terms_of_use_USA.pdf": 466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;